export default "__VITE_ASSET__BIEi1P1s__"